import { WorkerBootstrapper } from '../../utils/WorkerBootstrapper.js';

const bootstrapper = new WorkerBootstrapper();
void bootstrapper.bootstrap();
